import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import fonts from './fonts';
var textStyles = {
  lorem: _objectSpread({}, fonts.UniversRoman),
  h1: _objectSpread(_objectSpread({}, fonts.UniversBoldCondensed), {}, {
    fontSize: '1.7rem',
    lineHeight: '1.1666',
    textTransform: 'uppercase'
  }),
  h2Caps: _objectSpread(_objectSpread({}, fonts.UniversRoman), {}, {
    fontSize: '1.2rem',
    lineHeight: '1.1666',
    letterSpacing: '0.05em',
    textTransform: 'uppercase'
  }),
  h3: _objectSpread(_objectSpread({}, fonts.UniversBoldCondensed), {}, {
    fontSize: '1.2rem',
    lineHeight: '1.1666',
    textTransform: 'uppercase'
  }),
  text: _objectSpread(_objectSpread({}, fonts.UniversRoman), {}, {
    fontSize: '1.2rem',
    lineHeight: '1.5',
    letterSpacing: '0.02em'
  }),
  label: _objectSpread(_objectSpread({}, fonts.UniversRoman), {}, {
    fontSize: '1.2rem',
    lineHeight: '1.142',
    letterSpacing: '0.02em'
  }),
  tiny: _objectSpread(_objectSpread({}, fonts.UniversRoman), {}, {
    fontSize: '1.2rem',
    lineHeight: '1.5',
    letterSpacing: '0.02em'
  })
};
export default textStyles;